<template>
    <transition name="fade">
        <div class="loader" v-if="!finished">
            <div class="load-status-bar" :style="{ width: progress }"></div>
            <div class="icon"></div>
            <div class="overlay"></div>
        </div>
    </transition>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    computed: {
        ...mapState(['dataLoaded']),
        ...mapState('spinner', ['loadFinished', 'loaded', 'total']),
        finished() {
            return this.dataLoaded && this.loaded == this.total;
        },
        progress() {
            return (this.loaded / this.total) * 100 + '%';
        }
    },
    mounted() {
        this.initLoader();
    },
    methods: {
        ...mapActions('spinner', ['initLoader'])
    }
};
</script>

<style lang="scss">
</style>
